import React from 'react';
import { HashimotoTestEdge, useTranslator } from '@front-activerse/common-components';
import { Col, Container, Row, NavItem, Nav, Spinner } from 'reactstrap';
import { useParams, NavLink } from 'react-router-dom';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';
import { HashimotoTestMeasurementFieldEnum } from '../types';

interface ITestsHistoryContainer {
  hashimotoTestHistory: HashimotoTestEdge[];
  removeTest: any;
}

const TestsHistoryPlaceholder: React.FC<ITestsHistoryContainer> = ({
  hashimotoTestHistory,
  removeTest,
}) => {
  const { t } = useTranslator();
  const { category } = useParams<{ category: HashimotoTestMeasurementFieldEnum }>();

  const renderCategoryFilter = () => {
    const categories = [
      HashimotoTestMeasurementFieldEnum.TSH,
      HashimotoTestMeasurementFieldEnum.FT3,
      HashimotoTestMeasurementFieldEnum.FT4,
      HashimotoTestMeasurementFieldEnum.ANTI_TG,
      HashimotoTestMeasurementFieldEnum.ANTI_TPO,
    ];

    return (
      <div className="sub-navigation">
        <Container>
          <Nav className="d-block">
            {categories.map((cat) => (
              <NavItem key={cat}>
                <NavLink
                  to={`/lab-tests/history/${cat}`}
                  replace={true}
                  className={category === cat ? 'nav-link active' : 'nav-link'}
                >
                  {t(`labTests.${cat}`)}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Container>
      </div>
    );
  };

  return (
    <Layout>
      <div className="page-template-lab-tests full-height2">
        <TitleBar>{t('labTestsHistory.navbarTitle')}</TitleBar>
        {renderCategoryFilter()}
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 10, offset: 1 }}>
              <div className="loader-wrapper no-fixed">
                <Spinner color="primary">{t('loading.message')}</Spinner>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default TestsHistoryPlaceholder;
